import template from './OnboardingChecklist.html';
import './OnboardingChecklist.scss';
export class OnboardingChecklistController {
}
export const OnboardingChecklistComponent = {
    controller: OnboardingChecklistController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        heading: '@',
        steps: '<',
    },
};
